import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

export const getDetailCompany = createAsyncThunk('/dashboard_detail_company/content', async (id) => {
    const response = await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/dashDetailCompany/${id}`, {})
    return response.data;
})

export const dashboardDetailCompanySlice = createSlice({
    name: 'dashboard_detail_company',
    initialState: {
        isLoading: false,
        dashboard_detail_company: []
    },

    /*extraReducers: {
        [getDetailCompany.pending]: state => {
            state.isLoading = true
        },
        [getDetailCompany.fulfilled]: (state, action) => {
            state.dashboard_detail_company = action.payload.data
            state.isLoading = false
        },
        [getDetailCompany.rejected]: state => {
            state.isLoading = false
        },
    }*/
    extraReducers: (builder) => {
        builder
            .addCase(getDetailCompany.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getDetailCompany.fulfilled, (state, action) => {
                state.dashboard_detail_company = action.payload.data;
                state.isLoading = false;
            })
            .addCase(getDetailCompany.rejected, (state) => {
                state.isLoading = false;
            });                     
    }       
})

export default dashboardDetailCompanySlice.reducer